const money = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
};

export const payrollNetResult = ({
  storeGain = 0,
  membershipMarginRetained = 0,
  postedExpenses = 0,
} = {}) => Math.round((money(storeGain) + money(membershipMarginRetained) - money(postedExpenses)) * 100) / 100;
